const featuresConfig = {
  features: {
    esim: {
      active: true,
    },
    passolution: {
      // nur rex (themes/rex), siehe SKAGFO-461
      active: false,
      embedId: process.env.NEXT_PUBLIC_PASSOLUTION_EMBED_ID ?? '',
    },
    bookingSummary: {
      showBoarding: true,
    },
  },
}

export default featuresConfig
